// removed by extract-text-webpack-plugin
module.exports = {"overviewContainer":"index__overviewContainer--Hxprd","card":"index__card--UMnuc","imageContainer":"index__imageContainer--3Lqc2","image":"index__image--3iHef","cardContent":"index__cardContent--1J0At","textField":"index__textField--2q5lf","table":"index__table--1y-Fl","videoContainer":"index__videoContainer--3aAvC","linkGdrive":"index__linkGdrive--fpxpc","imgGdrive":"index__imgGdrive--2r4cM","dialogTitle":"index__dialogTitle--2oU2W"};


//////////////////
// WEBPACK FOOTER
// ./src/client/plugins/aiware/components/styles/index.scss
// module id = L4kk
// module chunks = 23